import { useEffect } from "react";
import ReactGA from "react-ga4";

import CV from "./pages/CV";

import { TRACKING_ID } from "./data/tracking";
import "./app.css";

function App() {
	useEffect(() => {
		if (TRACKING_ID !== "") {
			ReactGA.initialize(TRACKING_ID);
		}
	}, []);

	return (
		<div className="App">
			<CV />
		</div>
	);
}

export default App;
